import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { PageInfo } from '../../core';

@Component({
    selector: 'sm-pagination',
    template: require('./sm-pagination.component.html')
})
export class SmPaginationComponent implements OnChanges {
    @Input() pageInfo: PageInfo;
    @Input() pageSizes: number[] = [25, 50, 100];
    @Input() pageSizeEdit: boolean = true;

    @Output('onPageSizeChanged') onPageSizeChanged: EventEmitter<number> = new EventEmitter();
    @Output('onPageChanged') onPageChanged: EventEmitter<number> = new EventEmitter();

    pageNumber: number = 1;
    totalPages: number = 1;

    ngOnChanges() {
        this.pageNumber = this.pageInfo.page;
        this.calcTotalPages();
    }

    disabled() {
        return this.pageNumber > this.totalPages || this.pageNumber < 1;
    }

    goToPage() {
        if (this.pageNumber == this.pageInfo.page) {
            return;
        }
        this.pageChanged(this.pageNumber);
    }

    pageSizeChanged($event) {
        this.pageInfo.pageSize = $event;
        this.calcTotalPages();
        this.onPageSizeChanged.emit($event);
    }

    pageChanged($event) {
        this.onPageChanged.emit($event);
    }

    calcTotalPages() {
        this.totalPages = Math.floor(this.pageInfo.totalCount / this.pageInfo.pageSize) + 1;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-pagination.component.ts